



















































import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class UnsavedForm extends Vue {
  public isActive: boolean = false;

  mounted() {
    this.isActive = true;
    if (typeof window !== "undefined") {
      document.addEventListener("keyup", this.keyPress);
    }
  }

  beforeDestroy() {
    if (typeof window !== "undefined") {
      document.removeEventListener("keyup", this.keyPress);
    }
  }

  keyPress({ key }: any) {
    if (key == "Enter") {
      this.save();
    }
  }

  cancel() {
    this.$emit("cancel");
    this.$emit("close");
  }

  discard() {
    this.$emit("close");
    this.$emit("discard");
  }

  save() {
    this.$emit("close");
    this.$emit("save");
  }
}
